<template>
    <div>
        <el-row :gutter="20" justify="center">
            <el-col :span="24">
                <el-empty :description="i18n.tkey('lang_temporary_no_data')" v-show="null == list || list.length == 0">

                </el-empty>
            </el-col>

            <el-col :span="cols" v-for="(v, i) in list" :key="v.id">
                <IslandRecord
                    :obj="v"
                    @clickEdit="clickEdit"
                    @clickManage="clickManage"
                />
            </el-col>
        </el-row>
    </div>
</template>

<script setup>

import {inject, onBeforeMount, ref} from "vue";
import IslandRecord from "@/components/shopopee/island/islandRecord.vue";
import myUtil from "@/util/util";

const props = defineProps(["list"])
const emits = defineEmits(["clickEdit", "clickManage"])

const i18n = inject("i18n")
const cols = ref(24)

function clickEdit(obj){
    emits("clickEdit", obj)
}

function clickManage(obj){
    emits("clickManage", obj)
}

onBeforeMount(() => {
    if (!myUtil.isMobile()){
        cols.value = 20
    }
})

</script>

<style scoped>

</style>